import { useTranslation } from 'react-i18next';
import type { ClassKind } from '../lib/class-kind-filter';

interface ClassKindToggleProps {
  value: ClassKind;
  onChange: (next: ClassKind) => void;
}

const KINDS: ClassKind[] = ['regular', 'all'];

/** "Aulas regulares | Todas as aulas" pill, styled like ClassFilterToggle. */
export function ClassKindToggle({ value, onChange }: ClassKindToggleProps) {
  const { t } = useTranslation('admin');

  return (
    <div
      role="radiogroup"
      aria-label={t('p2e.classes.page.kindFilter.label')}
      className="inline-flex w-fit items-center gap-1 rounded-full border border-rose-200 bg-white p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.8),0_2px_0_rgba(0,0,0,0.04),0_4px_8px_rgba(247,141,167,0.08)]"
    >
      {KINDS.map((kind) => {
        const isActive = value === kind;
        return (
          <button
            key={kind}
            type="button"
            role="radio"
            aria-checked={isActive}
            onClick={() => onChange(kind)}
            className={
              'inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold transition-all duration-100 ease-out outline-none focus-visible:ring-2 focus-visible:ring-rose-300 ' +
              (isActive
                ? 'bg-gradient-to-b from-[#e04545] to-[#cf2e2e] text-white border border-[#cf2e2e]/60 border-b-[3px] border-b-[#a82424] shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_2px_0_rgba(0,0,0,0.15)] hover:translate-y-[1px] active:translate-y-[2px]'
                : 'text-gray-600 hover:text-[#cf2e2e]')
            }
          >
            {t(`p2e.classes.page.kindFilter.${kind}`)}
          </button>
        );
      })}
    </div>
  );
}
